const initJournal = () => {
    const article = document.querySelector('[data-journal-article]');
    if (!article) return;
    const content = article.querySelector('[data-journal-content]');
    const progress = article.querySelector('[data-journal-progress]');
    const toc = article.querySelector('[data-journal-toc]');
    const headings = [...article.querySelectorAll('[data-journal-heading]')];
    const links = [...article.querySelectorAll('.JournalToc nav a')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 1024px)');
    let scheduled = false;
    let activeId = '';

    article.querySelectorAll('[data-journal-products]').forEach(section => {
        const list = section.querySelector('.JournalProducts__list');
        const navigation = section.querySelector('.JournalProducts__navigation');
        const previous = section.querySelector('[data-journal-previous]');
        const next = section.querySelector('[data-journal-next]');
        const updateProducts = () => {
            const maximum = list.scrollWidth - list.clientWidth;
            navigation.hidden = maximum <= 2;
            previous.disabled = list.scrollLeft <= 2;
            next.disabled = list.scrollLeft >= maximum - 2;
        };
        const move = direction => list.scrollBy({ left: direction * list.clientWidth, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        list.addEventListener('scroll', updateProducts, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(updateProducts).observe(list);
        else window.addEventListener('resize', updateProducts, { passive: true });
        updateProducts();
    });

    if (toc) {
        const setDisclosure = () => { toc.open = desktop.matches; };
        setDisclosure();
        desktop.addEventListener('change', setDisclosure);
        links.forEach(link => link.addEventListener('click', event => {
            const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
            if (!target) return;
            event.preventDefault();
            if (!desktop.matches) toc.open = false;
            history.replaceState(null, '', link.hash);
            target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
            target.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'start' });
        }));
    }

    const update = () => {
        scheduled = false;
        if (!content) return;
        const bounds = content.getBoundingClientRect();
        const distance = Math.max(1, bounds.height - window.innerHeight * .6);
        const fraction = Math.min(1, Math.max(0, -bounds.top / distance));
        if (progress) progress.style.transform = `scaleX(${fraction})`;
        let current = '';
        headings.forEach(heading => {
            if (heading.getBoundingClientRect().top <= 150) current = heading.id;
        });
        if (current === activeId) return;
        activeId = current;
        links.forEach(link => {
            if (decodeURIComponent(link.hash.slice(1)) === current) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
        });
    };
    const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if ('ResizeObserver' in window && content) new ResizeObserver(schedule).observe(content);
    update();

};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initJournal, { once: true });
else initJournal();
